export function getResponsiveVisibleCount({
  containerWidth,
  itemsGap,
  itemWidths,
  minVisibleCount,
  moreWidth,
  rootGap,
}) {
  const totalItems = itemWidths.length

  if (totalItems === 0) {
    return 0
  }

  for (let visible = totalItems; visible >= minVisibleCount; visible--) {
    const hasMoreButton = visible < totalItems

    const itemsWidth = itemWidths
      .slice(0, visible)
      .reduce((sum, width) => sum + width, 0)

    const itemsGapWidth = (visible - 1) * itemsGap
    const moreAreaWidth = hasMoreButton ? rootGap + moreWidth : 0

    const usedWidth = itemsWidth + itemsGapWidth + moreAreaWidth

    if (usedWidth <= containerWidth) {
      return visible
    }
  }

  return minVisibleCount
}

export function readFlexGap(node) {
  if (!node) {
    return 0
  }

  const style = window.getComputedStyle(node)

  const columnGap = parseFloat(style.columnGap)

  if (Number.isFinite(columnGap)) {
    return columnGap
  }

  const gap = parseFloat(style.gap)

  return Number.isFinite(gap) ? gap : 0
}
